module.exports = __webpack_public_path__ + "static/media/hero-smartphone.74d756a8.png";